import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";

import { DatePicker, Space } from "antd";

const DateRange = (props) => {

	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const handleFilters = () => {
		props.setBody({
			...props.body,
			startDate,
			endDate
		  });
	}

	return (
		<ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
			<li className="d-flex align-items-center gap-10">
				<Space direction="horizontal">
					<DatePicker onChange={(date, dateString) => setStartDate(dateString)} placeholder="Start Date" className="form-control" style={{ height: "40px" }} />
					<DatePicker onChange={(date, dateString) => setEndDate(dateString)} placeholder="End Date" className="form-control" style={{ height: "40px" }} />
				</Space>
			</li>
			<li className="ml-2">
				<Button variant="secondary" onClick={handleFilters}>
					Go
				</Button>
			</li>
		</ul>
	);
};

export default DateRange;
